// group ids for security groups from microsoft graph
export enum UserPermission {
    SCREENER = 'SCREENER_GROUP_ID',
    ADMIN = 'ADMIN_GROUP_ID',

    // Steward AD Group
    MedNecScreen_User = 'cab938cc-03d0-4276-a6c9-cad341b41e58',
    MedNecScreen_Admin = '3a0ef0e4-c2d5-4363-9ab0-906299a38a2d',
    MedNecScreen_ISAdmin = '2c913f70-72ad-4414-899c-8559018a8310',

    // Quorum AD Group
    MedNecScreen_Quorum_User = 'c73b6386-092b-4817-8e02-321763bf2d49',
    MedNecScreen_Quorum_Admin = '1abbbcd4-74f5-4e18-bf31-f880f83fa7b4',
    MedNecScreen_Quorum_ISAdmin = 'bbf73dd0-5a66-45cd-9213-9dc97ba44c3a'
}

export function userPermissionFromGroupId(groupId: string): UserPermission | null {
    switch (groupId) {
        case UserPermission.SCREENER:
            return UserPermission.SCREENER;
        case UserPermission.ADMIN:
            return UserPermission.ADMIN;
        case UserPermission.MedNecScreen_User:
            return UserPermission.MedNecScreen_User;
        case UserPermission.MedNecScreen_Admin:
            return UserPermission.MedNecScreen_Admin;
        case UserPermission.MedNecScreen_ISAdmin:
            return UserPermission.MedNecScreen_ISAdmin;
        case UserPermission.MedNecScreen_Quorum_User:
            return UserPermission.MedNecScreen_Quorum_User;
        case UserPermission.MedNecScreen_Quorum_Admin:
            return UserPermission.MedNecScreen_Quorum_Admin;
        case UserPermission.MedNecScreen_Quorum_ISAdmin:
            return UserPermission.MedNecScreen_Quorum_ISAdmin;
        default:
            return null;
    }
}
